import {
  EventReasonCodeMapping,
  deliveryActiveStates,
  deliveryFailedStates,
  deliveryStates,
  deliverySuccessStates,
  pickUpStates,
  pickupFailedStates,
  pickupOngoingStates,
  pickupSuccessStates,
  returnActiveStates,
  returnFailedStates,
  returnSucessStates,
  riderAssignedStates,
} from "./consignmentStates.js";
import {imageBaseUrl} from "./getData.js";
import {setEventTitle, setStepState} from "./setData.js";
import {initMap} from "./initMap.js";
import {identifierIds, stateClasses} from "./statesAndIdentifiers.js";

const PEC = JSON.parse(sessionStorage.getItem("labels_config"));

export const getObjectKeys = (object) => {
  return Object.keys(object);
};

const setInnerHtml = (selector, html) => {
  $(selector)?.html(html);
};

export const markDeliveryOngoing = () => {
  setStepState(identifierIds.DELIVERY, stateClasses.ONGOING);
  setEventTitle(identifierIds.DELIVERY, "Delivered");
};
export const markPickupOngoing = () => {
  setStepState(identifierIds.PICKUP, stateClasses.ONGOING);
  setEventTitle(identifierIds.PICKUP, "Order is being Picked up");
};
export const markRiderAssigned = () => {
  setStepState(identifierIds.RIDER_ASSIGNED, stateClasses.COMPLETED);
  console.log(PEC);
  setEventTitle(
    identifierIds.RIDER_ASSIGNED,
    (PEC.riders.singular ?? "Rider") + " Assigned",
  );
  markPickupOngoing();
};

export const getTitle = (erCode) => {
  if (sessionStorage.getItem("labels_config")) {
    const data = JSON.parse(sessionStorage.getItem("labels_config"));
    if (EventReasonCodeMapping[erCode] == "Rider Assigned") {
      return data.riders.singular + " Assigned";
    }
    if (EventReasonCodeMapping[erCode] == "Shipment Created") {
      return data.shipment.singular + " Created";
    }
  }
  return EventReasonCodeMapping[erCode];
};

export const getMapMarkerObject = (position, label, icon) => {
  let long = position?.long;
  if (!long) long = position?.lon;

  return {
    position: {lat: Number(position?.lat), lng: Number(long)},
    label,
    icon,
  };
};

export const checkCategory = (erCode) => {
  if (deliveryStates[erCode]) return "DELIVERY";
  if (pickUpStates[erCode]) return "PICKUP";
};
export const checkRiderStatus = (erCode) => {
  if (riderAssignedStates?.includes(erCode)) return stateClasses.COMPLETED;
  return stateClasses.COMPLETED;
};

export const isLastPickupFailed = (events) => {
  const {previousAttempt, currentAttempt} = events;
};

export const pickupFailedDom = (index, prevFailedEventArray) => {
  const parentDiv = document.createElement("div");

  const pickupArray = prevFailedEventArray.pickup;

  const dateTimeStampLastFailed =
    pickupArray[pickupArray?.length - 1]?.timestamp;

  const domElement = `<div
                class="step failedEvent attempted completed"
                id=${`previous-attempt-failed-pickup-${index}`}
                style="display: inline-flex"
              >
                <div class="count-circle completed pick-up">
                  <a href="#" class="state-info" title="Delivery Failed"> </a>
                </div>
                <div class="info">
                  <p
                    class="title attempted-text"
                    aria-label="Delivery Failed"
                  >
                  Pickup Unsuccessful
                  </p>
                  <p class="date-text" id=${`order-failed-date-pickup-${index}`}>
                    ${dateTimeStampLastFailed}
                  </p>
                  <div
                    class="all-update failed-top arrow update-btn-${index}"
                    role="button"
                    aria-label="All Updates"
                  >
                    <a href="#" class="all-update-btn">
                      All Updates
                        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M11.8189 3.95112L6.39523 8.86004C6.18643 9.04648 5.87331 9.04648 5.66434 8.86004L0.180326 3.95112C-0.0433027 3.71931 -0.0613703 3.40568 0.139759 3.18069C0.353843 2.94547 0.698831 2.94888 0.91121 3.13978L5.99979 7.72144L11.0894 3.13978C11.3142 2.93944 11.6583 2.95703 11.8605 3.18028C12.0609 3.40568 12.0439 3.71931 11.8189 3.95112Z" fill="#7C3AED"/>
                        </svg>
                    </a>
                  </div>

                  <!-- All Updates start-->
                  <div class="topupdate-wrapper topupdate-wrapper-${index}">
                    <div class="allupdate-wrapper" id=${`previous-attempt-${index}`}>
                      <div class="steps ${`del-steps-${index}`}" " id="steps">

                      </div>
                    </div>
                  </div>
                </div>
              </div>`;

  parentDiv.innerHTML = domElement;

  return parentDiv;
};

export const returnFailedDom = (index, prevFailedEventArray) => {
  const parentDiv = document.createElement("div");

  const pickupArray = prevFailedEventArray.pickup;

  const dateTimeStampLastFailed = pickupArray[pickupArray.length - 1].timestamp;

  const domElement = `<div
                class="step failedEvent attempted completed"
                id=${`previous-attempt-failed-pickup-${index}`}
                style="display: inline-flex"
              >
                <div class="count-circle completed pick-up">
                  <a href="#" class="state-info" title="Delivery Failed"> </a>
                </div>
                <div class="info">
                  <p
                    class="title attempted-text"
                    aria-label="Delivery Failed"
                  >
                  Return Unsuccessful
                  </p>
                  <p class="date-text" id=${`order-failed-date-pickup-${index}`}>
                    ${dateTimeStampLastFailed}
                  </p>
                  <div
                    class="all-update failed-top arrow update-btn-${index}"
                    role="button"
                    aria-label="All Updates"
                  >
                    <a href="#" class="all-update-btn">
                      All Updates
                        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M11.8189 3.95112L6.39523 8.86004C6.18643 9.04648 5.87331 9.04648 5.66434 8.86004L0.180326 3.95112C-0.0433027 3.71931 -0.0613703 3.40568 0.139759 3.18069C0.353843 2.94547 0.698831 2.94888 0.91121 3.13978L5.99979 7.72144L11.0894 3.13978C11.3142 2.93944 11.6583 2.95703 11.8605 3.18028C12.0609 3.40568 12.0439 3.71931 11.8189 3.95112Z" fill="#7C3AED"/>
                        </svg>
                    </a>
                  </div>

                  <!-- All Updates start-->
                  <div class="topupdate-wrapper topupdate-wrapper-${index}">
                    <div class="allupdate-wrapper" id=${`previous-attempt-${index}`}>
                      <div class="steps ${`del-steps-${index}`}" " id="steps">

                      </div>
                    </div>
                  </div>
                </div>
              </div>`;

  parentDiv.innerHTML = domElement;

  return parentDiv;
};

const getTargetDom = (
  type,
  event,
  isReverseOrder,
  isCurrentSteps,
  attemptCount,
  markers,
  state,
  failedObject,
) => {
  const index = 0;
  let currenttype = type;

  // fetch date , reason and data
  // check if success or failed
  const ERCode =
    event?.eventCode + (event?.reasonCode ? `-${event?.reasonCode}` : "");
  let stepState = checkPickupStatus(ERCode);
  if (!stepState) stepState = checkDeliveryStatus(ERCode);
  const dateTime = event?.timestamp;
  let title = getTitle(ERCode);

  if (
    currenttype == "misc" &&
    !Object.keys(failedObject).includes("delivery")
  ) {
    if (event.state === "completed:delivered") {
      currenttype = "delivery";
      stepState = stateClasses.SUCCESS;
    }

    if (event.state === "closed:closed") {
      currenttype = "delivery";
      stepState = stateClasses.FAILED;
    }

    if (event.state === "completed:delivered" && isReverseOrder) {
      currenttype = "return";
      stepState = stateClasses.SUCCESS;
    }

    if (event.state === "closed:closed" && isReverseOrder) {
      currenttype = "return";
      stepState = stateClasses.FAILED;
    }
  }

  title =
    stepState == stateClasses.FAILED
      ? currenttype == "pickup"
        ? "Pickup Unsuccessful"
        : "Not Delivered"
      : title;

  if (isReverseOrder && stepState == stateClasses.FAILED) {
    if (currenttype == "pickup") title = "Pickup Unsuccessful";
    else title = "Return Failed";
  }

  if (!isReverseOrder && stepState == stateClasses.FAILED) {
    if (currenttype == "pickup") title = "Pickup Unsuccessful";
    else title = "Not Delivered";
  }

  title =
    stepState == stateClasses.SUCCESS
      ? currenttype == "delivery"
        ? "Delivered"
        : currenttype == "return"
          ? "Return Received"
          : title
      : title;

  let reasoning = getTitle(ERCode);

  const currentStepClass = isCurrentSteps ? "" : "";

  const pickupFailedClass = isCurrentSteps
    ? "step-order-failed failed-info"
    : "failed-info sml-failed";
  const pickupSuccessClass = isCurrentSteps
    ? event?.eventCode
      ? "step-completed"
      : ""
    : "sml-success";

  const deliveryFailedClass = isCurrentSteps
    ? "step-order-failed failed-info"
    : "failed-info sml-failed";
  const deliverySuccessClass = isCurrentSteps
    ? event?.eventCode
      ? "step-success "
      : ""
    : "sml-success";

  const pickupClass = isCurrentSteps ? "" : "previous-step-pickup";
  const deliveryClass = isCurrentSteps ? "" : "previous-step-delivery";

  const isFailedEvent = stepState == stateClasses.FAILED;

  const riderDom = `<div
                            class="step ${currentStepClass} ${isFailedEvent ? "failed-info sml-failed" : "sml-success step-completed"}"
                            id=${`previous-step-assigned-${index}`}
                          >
                            <div class="count-circle">
                              <a href="#" title="Completed"> </a>
                            </div>
                            <div class="info">
                              <p class="title">${title}</p>
                              <p class="date-text">${dateTime}</p>
                            </div>
                          </div>`;

  const pickupDom = `                          <div
                            class="${currentStepClass} ${pickupClass} step ${isFailedEvent ? pickupFailedClass : pickupSuccessClass}"
                            id=${`${pickupClass}-${index}`}
                          >
                            <div class="count-circle">
                              <a href="#" title="Completed"> </a>
                            </div>
                            <div class="info">
                              <p class="title">${title ?? "Picked Up"}</p>
                              ${isReverseOrder && isFailedEvent && reasoning ? `<p class="reasoning">${reasoning}</p>` : ``}
                              ${dateTime ? `<p class="date-text">${dateTime}</p>` : ""}
                            </div>
                          </div>`;

  const deliveryDom = `                       <div
                            class="${currentStepClass} ${deliveryClass} step ${isFailedEvent ? deliveryFailedClass : deliverySuccessClass}"
                            id=${`${deliveryClass}-${index}`}
                          >
                            <div class="count-circle">
                              <a href="#" title="Completed"> </a>
                            </div>
                            <div class="info ">
                              <p class="title">
                                ${title ? title : isReverseOrder ? "Return Received" : "Delivered"}
                                <!-- Out for Delivery -->
                              </p>

                              ${!isReverseOrder && reasoning ? `<p class="reasoning">${reasoning}</p>` : ""}

                              ${dateTime ? `<p class="date-text">${dateTime}</p>` : ""}
                            </div>
                          </div>`;

  switch (currenttype) {
    case "rider":
      return riderDom;
    case "pickup":
      return pickupDom;
    case "delivery":
      return deliveryDom;
    case "return":
      return deliveryDom;
    default:
      return "";
  }
};

const appendChild = (
  parentClass,
  type,
  childArrayLength,
  eventArray,
  isReverseOrder,
  isCurrentSteps,
  attemptCount,
  markers,
  state,
  failedObject,
) => {
  const parent = document.querySelector(parentClass);

  eventArray.forEach((event) => {
    const childDom = getTargetDom(
      type,
      event,
      isReverseOrder,
      isCurrentSteps,
      attemptCount,
      markers,
      state,
      failedObject,
    );
    if (childDom) {
      let divElement = document.createElement("div");
      divElement.classList.add("step-wrapper");
      divElement.innerHTML = childDom;
      parent.append(divElement);
    }
  });
};

export const HyderateAllUpdatesSection = (
  failedObject,
  previousAttemptTypes,
  isReverseOrder,
  parentClass,
  isCurrentSteps,
  attemptCount,
  markers,
  state,
) => {
  for (let key in failedObject) {
    appendChild(
      parentClass,
      key,
      failedObject[key].length,
      failedObject[key],
      isReverseOrder,
      isCurrentSteps,
      attemptCount,
      markers,
      state,
      failedObject,
    );
  }
};

export const deliveryFailedDom = (
  index,
  prevFailedEventArray,
  prevFailedArrayLogic,
) => {
  const parentDiv = document.createElement("div");

  const deliveryArray = prevFailedEventArray.delivery;

  const dateTimeStampLastFailed =
    deliveryArray[deliveryArray.length - 1].timestamp;

  const domElement = `<div
                  class="failedEvent step attempted completed"
                  id=${`previous-attempt-failed-delivery-${index}`}
                  style="display: inline-flex"
                >
                  <div class="count-circle completed pick-up">
                    <a href="#" class="state-info" title="Delivery Unsuccessful"> </a>
                  </div>
                  <div class="info">
                    <p
                      class="title attempted-text"
                      aria-label="Delivery Failed"
                    >
                     Delivery Unsuccessful
                    </p>
                    <p class="date-text"  id="order-failed-date-${index}">
                        ${dateTimeStampLastFailed}
                    </p>
                    <div
                      class="all-update failed-top arrow update-btn-${index}"
                      role="button"
                      aria-label="All Updates"
                    >
                      <a href="#" class = "all-update-btn">
                       All Updates
                        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M11.8189 3.95112L6.39523 8.86004C6.18643 9.04648 5.87331 9.04648 5.66434 8.86004L0.180326 3.95112C-0.0433027 3.71931 -0.0613703 3.40568 0.139759 3.18069C0.353843 2.94547 0.698831 2.94888 0.91121 3.13978L5.99979 7.72144L11.0894 3.13978C11.3142 2.93944 11.6583 2.95703 11.8605 3.18028C12.0609 3.40568 12.0439 3.71931 11.8189 3.95112Z" fill="#7C3AED"/>
                        </svg>
                      </a>
                    </div>

                    <!-- All Updates start-->
                    <div class="topupdate-wrapper topupdate-wrapper-${index}">
                      <div class="allupdate-wrapper" id="previous-attempt-${index}">
                        <div class="steps ${`del-steps-${index}`}" id="steps">
  


                        </div>
                      </div>
                    </div>
                  </div>
                </div>`;

  parentDiv.innerHTML = domElement;

  return parentDiv;
};

export const checkPickupStatus = (erCode) => {
  // handle pickup failed state also here...
  if (pickupSuccessStates.includes(erCode)) return stateClasses.COMPLETED;
  if (deliveryFailedStates.includes(erCode)) return stateClasses.FAILED;
  if (pickupOngoingStates.includes(erCode)) return stateClasses.ATTEMPTED;
  if (pickupFailedStates.includes(erCode)) return stateClasses.FAILED;
};
export const checkDeliveryStatus = (erCode) => {
  if (deliverySuccessStates.includes(erCode)) return stateClasses.SUCCESS;
  if (deliveryFailedStates.includes(erCode)) return stateClasses.FAILED;
  if (deliveryActiveStates.includes(erCode)) return stateClasses.ATTEMPTED;
};

export const checkReturnStatus = (erCode) => {
  if (returnSucessStates.includes(erCode)) return stateClasses.SUCCESS;
  if (returnFailedStates.includes(erCode)) return stateClasses.FAILED;
  if (returnActiveStates.includes(erCode)) return stateClasses.ATTEMPTED;
};

// export const previousDelhiveryStatus = (erCode) => {
// 	if (deliverySuccessStates.includes(erCode)) return stateClasses.COMPLETED;
// 	if (deliveryFailedStates.includes(erCode)) return stateClasses.FAILED;
// 	if (deliveryActiveStates.includes(erCode)) return stateClasses.ATTEMPTED;
// };

export const getAllStateClassesExcept = (classNameToExclude) => {
  let classString = "";
  for (let className in stateClasses) {
    if (stateClasses[className] !== classNameToExclude) {
      classString += stateClasses[className] + " ";
    }
  }
  return classString;
};
